import React, { Component } from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import { setInfo, setCurrent, setLatest } from '../../store/actions/FormAction';

class NextInfoButton extends Component {
    constructor(){
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
      if (!this.props.disableNext) {
        let nextstep = parseInt(this.props.infostep, 10)+1;
        if (nextstep > 3) nextstep = 3;
        this.props.setInfo(nextstep);
        let currentstep = nextstep+2;
        this.props.setCurrent(currentstep);
        if (parseInt(this.props.lateststep, 10) < currentstep)
          this.props.setLatest(currentstep);
      } else {
        e.preventDefault();
      }
    }

    render() {
      let addDisabledToClasses = this.props.btnClasses + " disabled";

      let nextLink = this.props.next;
      if (this.props.notserved)
        nextLink = '/noservice';
      else if (this.props.tooyoung)
        nextLink = '/notapproved';

      if (this.props.hideNext){
        return "";
      }
      switch(this.props.disableNext){
        case true:
          return (
            <Link className={addDisabledToClasses} to="/#" >
              <span>{this.props.btnText}</span>
            </Link>
          )
        default:
          return (
            <Link id={this.props.id} className={this.props.btnClasses} to={nextLink} onClick={this.handleClick} tabIndex={this.props.tabIndex} >
              <button type="submit">{this.props.btnText}</button>
            </Link>
          )
      }
    }
}

const mapStateToProps = (state) => ({
    tooyoung: state.FormReducer.tooyoung,
    notserved: state.FormReducer.notserved,
    lateststep: state.FormReducer.lateststep
});

const mapDispatchToProps = (dispatch) => ({
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep)),
});
/*
    Can put mapStateToProps or state => ({}) as first param of connect()
    Using mapStateToProps for simplicity and stylistic preference
*/
export default connect(mapStateToProps, mapDispatchToProps)(NextInfoButton)



// WEBPACK FOOTER //
// ./src/components/partials/NextInfoButton.js